import ReactPaginate from "react-paginate";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import "./paginate.css";
import {
  LeftActiveArrow,
  LeftArrow,
  RightActiveArrow,
  RightArrow,
} from "../svgs/rightActiveArrow";
const Paginate = ({
  currentPage,
  pageCount,
  setCurrentPage,
  previousLabel,
  nextLabel,
  clearData,
  setCurrentPageandResetData,
}) => {
  const handlePageClick = ({ selected: selectedPage }) => {
    setCurrentPageandResetData
      ? setCurrentPageandResetData(setCurrentPage, selectedPage + 1, clearData)
      : setCurrentPage(selectedPage + 1);
  };

  return (
    <div
      className="justify-content-center d-flex w-100 py-3"
      dir={getDir(getCurrentLangFromRedux())}
    >
      <ReactPaginate
        previousLabel={
          previousLabel ?? currentPage == 1 ? (
            <RightArrow
              style={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? { transform: "unset" }
                  : { transform: "scaleX(-1)" }
              }
            />
          ) : (
            <RightActiveArrow
              style={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? { transform: "unset" }
                  : { transform: "scaleX(-1)" }
              }
            />
          )
        }
        nextLabel={
          nextLabel ?? pageCount == currentPage ? (
            <LeftArrow
              style={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? { transform: "unset" }
                  : { transform: "scaleX(-1)" }
              }
            />
          ) : (
            <LeftActiveArrow
              style={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? { transform: "unset" }
                  : { transform: "scaleX(-1)" }
              }
            />
          )
        }
        forcePage={currentPage - 1}
        pageCount={pageCount}
        pageRangeDisplayed={1}
        marginPagesDisplayed={1}
        onPageChange={handlePageClick}
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
      />
    </div>
  );
};

export default Paginate;
